import { Button, Modal, ModalFooter, toast } from '@7shifts/sous-chef';
import { __ } from 'i18n/translate';
import { useState } from 'react';
import { deleteFeatureFlag } from 'adminPanel/api/companies';
import { handleError } from 'api/apiUtils';

type Props = {
    onClose: () => void;
    companyId: number;
    featureId: number;
    onSuccess: () => void; // Optional callback for success
};
const DeleteCompanyFeatureModal = ({
    onClose,
    companyId,
    featureId,
    onSuccess
}: Props) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDeleteFeature = () => {
        setIsDeleting(true);
        deleteFeatureFlag(companyId, featureId)
            .then(() => {
                toast(__('adminpanel.featureFlagDeleted'));
                onSuccess();
                onClose();
            })
            .catch(handleError)
            .finally(() => {
                setIsDeleting(false);
            });
    };

    return (
        <Modal
            header={__('main.confirmDeleteDomain', {
                domainName: __('adminpanel.featureFlag')
            })}
            onClose={onClose}
        >
            <ModalFooter
                actions={{
                    primary: (
                        <Button
                            onClick={handleDeleteFeature}
                            loading={isDeleting}
                            theme="danger"
                        >
                            {__('main.delete')}
                        </Button>
                    ),
                    secondary: (
                        <Button onClick={onClose}>{__('main.cancel')}</Button>
                    )
                }}
            />
        </Modal>
    );
};

export default DeleteCompanyFeatureModal;
